import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { LoadingState, ValidationError } from '../../../types/commonTypes'
import { ApiLoadingState } from '../../../middleware/api/apiList'
import { RootState } from '../../../stateStore'
import { appraisalCardAPI } from '../../../middleware/api/Finance/AppraisalLetters/appraisalLettersApi'
import {
  appraisalCardDetails,
  appraisalCardGetAPIResponse,
  AppraisalCardGetProps,
  appraisalFilesState,
} from '../../../types/Finance/AppraisalCardUpload/AppraisalCradTypes'

const downloadAppraisalFile = createAsyncThunk(
  'appraisalCardUpload/downloadAppraisalFile',
  async (
    {
      empId,
      year,
      fullName,
    }: {
      empId: number
      year: string
      fullName: string
    },
    thunkApi,
  ) => {
    try {
      return await appraisalCardAPI.downloadAppraisalFile({
        empId,
        year,
        fullName,
      })
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)
const getAppraisalFiles = createAsyncThunk(
  'appraisalCardUpload/getAppraisalFiles',
  async (props: AppraisalCardGetProps, thunkApi) => {
    try {
      return await appraisalCardAPI.getAppraisalFiles(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const saveAppraisalFileForYear = createAsyncThunk(
  'appraisalCardUpload/saveAppraisalFileForYear',
  async (
    {
      empId,
      year,
      fullName,
    }: {
      empId: number
      year: string
      fullName: string
    },
    thunkApi,
  ) => {
    try {
      return await appraisalCardAPI.saveAppraisalFileForYear({
        empId,
        year,
        fullName,
      })
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)
export const appraisalCardUploadState: appraisalFilesState = {
  isLoadingGet: ApiLoadingState.idle,
  getAppraisalFiles: {
    size: 0,
    list: [] as appraisalCardDetails[],
  },
  paginationProps: {
    currentPage: 1,
    pageSize: 20,
  },
  search: '',
  year: '',
}

const appraisalLetters = createSlice({
  name: 'appraisalCardUpload',
  initialState: appraisalCardUploadState,
  reducers: {
    setPaginationProps: (state, action) => {
      state.paginationProps = action.payload
    },
    setSearch: (state, action) => {
      state.search = action.payload
    },
    setYear: (state, action) => {
      state.year = action.payload
    },
  },
  extraReducers(builder) {
    builder.addCase(getAppraisalFiles.pending, (state) => {
      state.isLoadingGet = ApiLoadingState.loading
    })
    builder.addCase(getAppraisalFiles.fulfilled, (state, action) => {
      state.isLoadingGet = ApiLoadingState.succeeded
      state.getAppraisalFiles = action.payload
    })
  },
})

const getAllAppraisalFiles = (state: RootState): appraisalCardGetAPIResponse =>
  state.appraisalLetters.getAppraisalFiles

const isLoadingGet = (state: RootState): LoadingState =>
  state.appraisalLetters.isLoadingGet
const getYear = (state: RootState): string => state.appraisalLetters.year
const getSearch = (state: RootState): string => state.appraisalLetters.search
const getPaginationProps = (
  state: RootState,
): {
  currentPage: number
  pageSize: number
} => state.insurance.paginationProps

const appraisalLettersThunk = {
  getAppraisalFiles,
  downloadAppraisalFile,
  saveAppraisalFileForYear,
}

const appraisalLettersSelectors = {
  isLoadingGet,
  getAllAppraisalFiles,
  getPaginationProps,
  getSearch,
  getYear,
}
export const appraisalLettersService = {
  ...appraisalLettersThunk,
  actions: appraisalLetters.actions,
  selectors: appraisalLettersSelectors,
}
export default appraisalLetters.reducer
